import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../Partials/Layout";
import Ads from "./Ads";
import Banner from "./Banner";
import marketing_material_popup from "../../images/popup/MarketingMaterials.jpg";
import datas from "../../data/products.json";

// import SectionStyleFour from "../Helpers/SectionStyleFour";
// import SectionStyleOne from "../Helpers/SectionStyleOne";
// import SectionStyleThree from "../Helpers/SectionStyleThree";
// import SectionStyleTwo from "../Helpers/SectionStyleTwo";
// import ViewMoreTitle from "../Helpers/ViewMoreTitle";
// import BestSellers from "./BestSellers";
// import BrandSection from "./BrandSection";
// import CampaignCountDown from "./CampaignCountDown";
// import ProductsAds from "./ProductsAds";

export default function Home() {
  /* Token validation */
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect"); // currentlocation?redirect="/haneol" : <Link to={`/register?redirect=${redirect}`}>
  const redirect = redirectInUrl ? redirectInUrl : "/login";

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, loading, error, tokenerror } = userSignin;

  /*  Welcome popup with AR Summary */
  const invoicePermission =
    userInfo?.result?.user?.permissions &&
    userInfo?.result?.user?.permissions?.Invoice === 1;

  /* Layout */
  const { products } = datas;
  const brands = [];
  products.forEach((product) => {
    brands.push(product.brand);
  });

  /* Welcome popup with AR Summary */
  const [ads, setAds] = useState(false);

  /* Welcome popup introduce a new feature popup */
  const [showPopup, setShowPopup] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  /* Welcome popup with AR Summary */
  const adsHandle = () => {
    setAds(false);
  };
  useEffect(() => {
    setAds(true);
  }, []);

  /* login */
  useEffect(() => {
    if (!userInfo) {
      // alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      // redirect to login page after delete cookie
      navigate(redirect);
    } else {
    }
  }, [dispatch, navigate, redirect, userInfo]);

  /* Welcome popup introduce a new feature popup */
  useEffect(() => {
    const hidePopup = localStorage.getItem("hideWelcomePopup");
    if (!hidePopup) {
      const timer = setTimeout(() => {
        // setShowPopup(true); // popup trigger
      }, 2500); // 2.5 seconds delay

      // Clean up the timer if component unmounts
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClosePopup = () => {
    if (dontShowAgain) {
      localStorage.setItem("hideWelcomePopup", "true");
    }
    setShowPopup(false);
  };

  return (
    <>
      <Layout>
        {/* Welcome popup with AR Summary */}
        {/* {invoicePermission && ads && <Ads handler={adsHandle} />} */}
        {/* Welcome popup introduce a new feature popup */}
        {showPopup && (
          <div className="popup-wrapper">
            <div className="popup-close-button" onClick={handleClosePopup}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M1.5 16.5L16.5 1.5M16.5 16.5L1.5 1.5"
                  stroke="#5F5F5F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <Link to="/MarketingMaterials">
              <div className="popup-container">
                <img
                  src={marketing_material_popup}
                  alt="Marketing Material Popup"
                  className="popup-image"
                />
              </div>
            </Link>

            <div
              className="popup-footer"
              onClick={() => setDontShowAgain(!dontShowAgain)}
            >
              <div className="custom-checkbox">
                {dontShowAgain ? (
                  // Checked
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="14"
                      height="14"
                      stroke="#A9A9A9"
                    />
                    <path
                      d="M5.775 12.0187L1.5 7.74375L2.56875 6.675L5.775 9.88125L12.6562 3L13.725 4.06875L5.775 12.0187Z"
                      fill="#EFEFEF"
                    />
                  </svg>
                ) : (
                  // Unchecked
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="14"
                      height="14"
                      stroke="#A9A9A9"
                    />
                  </svg>
                )}
              </div>
              <span className="dont-show-text">Don’t show this again</span>
            </div>
          </div>
        )}
        <div className="btn w-5 h-5 "></div>
        <Banner className="banner-wrapper mb-[60px]" />
        {/*  <SectionStyleOne
          products={products}
          brands={brands}
          categoryTitle="Mobile & Tablet"
          sectionTitle="Gamer World"
          seeMoreUrl="/all-products"
          className="category-products mb-[60px]"
          />     
        <BrandSection
          sectionTitle="Shop by Brand"
          className="brand-section-wrapper mb-[60px]"
        /> 
        <CampaignCountDown
          className="mb-[60px]"
          lastDate="2023-03-04 4:00:00"
        /> 
        <ViewMoreTitle
          className="top-selling-product mb-[60px]"
          seeMoreUrl="/all-products"
          categoryTitle="Top Selling Products"
        > 
          <SectionStyleTwo products={products.slice(3, products.length)} />
        </ViewMoreTitle> 
    
        <ViewMoreTitle
          className="best-sallers-section mb-[60px]"
          seeMoreUrl="/sallers"
          categoryTitle="Best Saller"
        >
          <BestSellers />
        </ViewMoreTitle>
           
        <ProductsAds
          ads={[
            `${process.env.PUBLIC_URL}/assets/images/ads-1.png`,
            `${process.env.PUBLIC_URL}/assets/images/ads-2.png`,
          ]}
          sectionHeight="sm:h-[295px] h-full"
          className="products-ads-section mb-[60px]"
        />
      
        <SectionStyleOne
          categoryBackground={`${process.env.PUBLIC_URL}/assets/images/section-category-2.jpg`}
          products={products.slice(4, products.length)}
          brands={brands}
          categoryTitle="Electronics"
          sectionTitle="Popular Sales"
          seeMoreUrl="/all-products"
          className="category-products mb-[60px]"
        />    
      
        <ProductsAds
          ads={[`${process.env.PUBLIC_URL}/assets/images/ads-3.png`]}
          className="products-ads-section mb-[60px]"
        />

         <SectionStyleThree
          products={products}
          sectionTitle="New Arrivals"
          seeMoreUrl="/all-products"
          className="new-products mb-[60px]"
        />  
        <ProductsAds
          sectionHeight="164"
          ads={[`${process.env.PUBLIC_URL}/assets/images/ads-4.png`]}
          className="products-ads-section mb-[60px]"
        /> 
        <SectionStyleFour
          products={products}
          sectionTitle="Popular Sales"
          seeMoreUrl="/all-products"
          className="category-products mb-[60px]"
        />   
        */}
      </Layout>
    </>
  );
}
